import SignatureDetailsSummary from '../../features/parcel-creation/signature-details-summary/signature-details-summary.component';

const ParcelSignature = () => <SignatureDetailsSummary />;

export default ParcelSignature;
